import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';

function AppLayout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [sidebarMobileVisible, setSidebarMobileVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Detect screen size changes
  useEffect(() => {
    const checkScreenSize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);

      // On mobile, if sidebar becomes visible, we should hide it when screen gets larger
      // On desktop, reset mobile visibility
      if (!mobile && sidebarMobileVisible) {
        setSidebarMobileVisible(false);
      }
    };

    checkScreenSize(); // Check on mount
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, [sidebarMobileVisible]);

  // Close mobile sidebar when clicking outside (on mobile)
  useEffect(() => {
    const handleClickOutside = event => {
      if (isMobile && sidebarMobileVisible) {
        // Check if click is outside sidebar
        const sidebar = document.querySelector('.sidebar');
        const header = document.querySelector('.navbar');

        if (
          sidebar &&
          !sidebar.contains(event.target) &&
          header &&
          !header.contains(event.target)
        ) {
          setSidebarMobileVisible(false);
        }
      }
    };

    if (isMobile && sidebarMobileVisible) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMobile, sidebarMobileVisible]);

  const toggleSidebar = () => {
    if (isMobile) {
      // On mobile, toggle visibility
      setSidebarMobileVisible(!sidebarMobileVisible);
    } else {
      // On desktop, toggle collapsed state
      setSidebarCollapsed(!sidebarCollapsed);
    }
  };

  return (
    <div className={`app-container ${sidebarCollapsed ? 'sidebar-collapsed' : ''} layout-stable`}>
      <Header toggleSidebar={toggleSidebar} />
      <div className="content-with-sidebar">
        <Sidebar
          collapsed={sidebarCollapsed}
          mobileVisible={sidebarMobileVisible}
          isMobile={isMobile}
        />
        <main className="main-content">
          <div className="main-content-scrollable">
            <Outlet />
          </div>
        </main>
      </div>
      {/* Mobile backdrop overlay */}
      {isMobile && sidebarMobileVisible && (
        <div className="mobile-sidebar-backdrop" onClick={() => setSidebarMobileVisible(false)} />
      )}
    </div>
  );
}

export default AppLayout;
